import { defineTemplate } from '../../../utils';

const BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/DISNEY/templates`;

export const disneyGrid = defineTemplate({
  mode: 'legacy',
  id: 'grid',
  clientId: 'DISNEY',
  handlerKey: 'DISNEY',
  title: 'Grilla',
  disabled: true,
  hiddenFromUI: true,
  thumbnail: {
    url: `${BASE}/thumbnails/grilla.png`,
    optimizedUrl: `${BASE}/thumbnails/optimized/grilla.png`,
    hoverVideo: `${BASE}/previews/grilla.mp4`,

    aspectRatio: 'vertical'
  },
  formFields: []
});
